import React, { FC } from "react"
import { NumericFormat, NumberFormatValues } from "react-number-format"

import clsx from "clsx"

export interface PriceInputProps {
  value: any
  className?: string
  inputClassName?: string
  onChange: (value: NumberFormatValues) => void
  errorText?: string
  disabled?: boolean
}

const PriceInput: FC<PriceInputProps> = ({
  value,
  errorText,
  className,
  inputClassName,
  onChange,
  disabled,
}) => {
  return (
    <div className={clsx("relative", className)}>
      <NumericFormat
        thousandSeparator="."
        decimalSeparator=","
        prefix="Rp."
        placeholder="Rp."
        value={value}
        valueIsNumericString
        disabled={disabled}
        className={clsx(
          inputClassName,
          "py-2.5 px-3 rounded w-full border-2 border-grey-ec lg:text-base",
          "focus:outline-none focus:shadow-outline focus:border-green active:shadow-outline active:border-green text-sm",
          value && !errorText && "border-2 !border-green",
          errorText && "!border-red border"
        )}
        onValueChange={(e) => onChange(e)}
      />
      <small className="text-red">{errorText}</small>
    </div>
  )
}

export default PriceInput
